import * as yup from "yup";
import YupPassword from "yup-password";
import i18n from "../../../../i18n";
import containsConsecutives from "../../../../utils/containsConsecutives";

YupPassword(yup);

yup.addMethod(yup.string, "containsConsecutives", function(errorMessage, len) {
    return this.test(`sequential-numbers-and-letters`, errorMessage, function(value) {
        const {path, createError} = this;
        return containsConsecutives(value, len) ? createError({path, message: errorMessage}) : true;
    });
});
const requiredMessage = () => i18n.t("validation.required", {ns: "common"});

const companyShape = yup.object().shape({
    company: yup.string().required(requiredMessage),
    subCompanies: yup
        .array()
        .of(yup.string())
        .required(requiredMessage)
        .min(1)
});

export const poolFormValidation = yup.object().shape({
    name: yup.string().required(requiredMessage),
    city: yup.string().required(requiredMessage),
    companies: yup.array().of(yup.string()),
    subCompanies: yup.array().of(yup.string()),
    companyInfoArray: yup
        .array()
        .of(companyShape)
        .required(requiredMessage)
        .min(1)
});
